import SharingButtonsComponent from '@/components/SharingButtons/SharingButtons'
import type { NotificationProps, StyleVariations } from '@/components/SharingButtons/types'

export interface SharingButtonsBlockProps {
  position?: 'left' | 'center' | 'right'
  notification?: NotificationProps
  variations?: StyleVariations
  sharingLabel?: string
  useDeviceHook?: () => boolean
}

const SharingButtonsBlock = ({
  variations = 'ghost-icons',
  position = 'left',
  notification,
  sharingLabel,
  useDeviceHook,
}: SharingButtonsBlockProps) => (
  <SharingButtonsComponent
    useDeviceHook={useDeviceHook}
    sharingLabel={sharingLabel}
    notification={notification}
    variations={variations}
    position={position}
  />
)

export default SharingButtonsBlock
